import { render, staticRenderFns } from "./tomaMuestraShow.vue?vue&type=template&id=53105623"
import script from "./tomaMuestraShow.vue?vue&type=script&lang=js"
export * from "./tomaMuestraShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports